import { FlagsState } from '@/store/flags/types';

export default {
    legacyQuestions: false,
    showQuestionSamples: false,
    showHiddenPlays: false,
    allowDeleteAll: false,
} as FlagsState;
